if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.demyrMobileMql = window.matchMedia('(max-width: 749px)');
        this.demyrCloseTimer = null;
        this.demyrOpenTimer = null;
        this.demyrScrollRaf = null;
        this.demyrIndicators = null;
        this.demyrDocument = null;
        this.demyrSlides = [];
      }

      hide() {
        if (!this.demyrMobileMql.matches) {
          super.hide();
          return;
        }

        if (this.demyrCloseTimer) window.clearTimeout(this.demyrCloseTimer);
        if (this.demyrOpenTimer) {
          window.clearTimeout(this.demyrOpenTimer);
          this.demyrOpenTimer = null;
        }

        this.classList.remove('demyr-modal-visible');
        this.classList.add('demyr-modal-closing');

        this.demyrCloseTimer = window.setTimeout(() => {
          super.hide();
          this.classList.remove('demyr-modal-closing');
          document.documentElement.classList.remove('demyr-product-modal-open');
          this.demyrCloseTimer = null;
        }, 320);
      }

      show(opener) {
        if (this.demyrCloseTimer) {
          window.clearTimeout(this.demyrCloseTimer);
          this.demyrCloseTimer = null;
        }

        if (this.demyrOpenTimer) {
          window.clearTimeout(this.demyrOpenTimer);
          this.demyrOpenTimer = null;
        }

        // Make sure no previous visible state survives a reopen.
        this.classList.remove('demyr-modal-visible', 'demyr-modal-closing');

        super.show(opener);
        this.showActiveMedia();

        if (!this.demyrMobileMql.matches) return;

        document.documentElement.classList.add('demyr-product-modal-open');
        this.demyrSetupMobileSlider();

        // Force the browser to paint the transparent [open] state first.
        // Then start the fade on a later frame; this fixes the missing fade-in
        // seen on mobile browsers / DevTools emulation.
        void this.offsetWidth;

        this.demyrOpenTimer = window.setTimeout(() => {
          this.classList.add('demyr-modal-visible');
          this.demyrOpenTimer = null;
        }, 24);
      }

      demyrSetupMobileSlider() {
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        this.demyrDocument = container;
        this.demyrSlides = Array.from(container.querySelectorAll(':scope > [data-media-id]'));

        if (!this.demyrSlides.length) {
          this.demyrSlides = Array.from(container.querySelectorAll('[data-media-id]'));
        }

        let indicators = this.querySelector('.demyr-modal-indicators');

        if (!indicators) {
          indicators = document.createElement('div');
          indicators.className = 'demyr-modal-indicators';
          indicators.setAttribute('aria-label', 'Navegação de imagens');
          this.appendChild(indicators);
        }

        this.demyrIndicators = indicators;
        indicators.innerHTML = '';

        this.demyrSlides.forEach((slide, index) => {
          const indicator = document.createElement('button');
          indicator.type = 'button';
          indicator.className = 'demyr-modal-indicator';
          indicator.setAttribute('aria-label', `Imagem ${index + 1} de ${this.demyrSlides.length}`);

          indicator.addEventListener('click', () => {
            container.scrollTo({
              left: slide.offsetLeft,
              behavior: 'smooth',
            });
          });

          indicators.appendChild(indicator);
        });

        if (!container.dataset.demyrModalSliderBound) {
          container.dataset.demyrModalSliderBound = 'true';

          container.addEventListener(
            'scroll',
            () => {
              if (this.demyrScrollRaf) cancelAnimationFrame(this.demyrScrollRaf);

              this.demyrScrollRaf = requestAnimationFrame(() => {
                this.demyrUpdateIndicators();
              });
            },
            { passive: true }
          );

        }

        this.demyrUpdateIndicators();
      }

      demyrGetCurrentIndex() {
        if (!this.demyrDocument || !this.demyrSlides.length) return 0;

        const viewportCenter = this.demyrDocument.scrollLeft + this.demyrDocument.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.demyrSlides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(viewportCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      demyrUpdateIndicators(index = this.demyrGetCurrentIndex()) {
        if (!this.demyrIndicators) return;

        this.demyrIndicators.querySelectorAll('.demyr-modal-indicator').forEach((indicator, indicatorIndex) => {
          const isActive = indicatorIndex === index;
          indicator.classList.toggle('is-active', isActive);

          if (isActive) {
            indicator.setAttribute('aria-current', 'true');
          } else {
            indicator.removeAttribute('aria-current');
          }
        });

      }

      showActiveMedia() {
        const openerMediaId = this.openedBy?.getAttribute('data-media-id');

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${openerMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${openerMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');

        if (this.demyrMobileMql.matches && container) {
          // On mobile the preview is now a real horizontal slider.
          // Do not use scrollIntoView(), because that can move the page behind
          // the modal and was part of the old/basic behaviour.
          requestAnimationFrame(() => {
            const slides = Array.from(container.querySelectorAll(':scope > [data-media-id]'));
            const activeIndex = Math.max(0, slides.indexOf(activeMedia));

            container.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'auto',
            });

            this.demyrUpdateIndicators(activeIndex);
          });
        } else {
          activeMedia.scrollIntoView();

          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}